import { render, staticRenderFns } from "./hiTags.vue?vue&type=template&id=c28ebb38&"
import script from "./hiTags.vue?vue&type=script&lang=js&"
export * from "./hiTags.vue?vue&type=script&lang=js&"
import style0 from "./hiTags.vue?vue&type=style&index=0&id=c28ebb38&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports